// Wait for everything to load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGalleryNavigation);
} else {
  initGalleryNavigation();
}

function initGalleryNavigation() {
  setTimeout(() => {
    const productGallery = document.querySelector('product-gallery');
    if (!productGallery) return;
    
    const carousel = productGallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;
    
    // Track current index
    let currentSlideIndex = 0;
    let prevButton, nextButton;
    
    // Get all slides
    const getAllSlides = () => {
      return Array.from(carousel.querySelectorAll('.product-gallery__media:not([hidden])'));
    };
    
    // Create and append arrows
    function createArrows() {
      // Remove existing arrows if they exist
      const existingPrev = productGallery.querySelector('.gallery-nav-arrow--prev');
      const existingNext = productGallery.querySelector('.gallery-nav-arrow--next');
      if (existingPrev) existingPrev.remove();
      if (existingNext) existingNext.remove();
      
      // Create new arrows
      prevButton = document.createElement('button');
      nextButton = document.createElement('button');
      
      prevButton.className = 'gallery-nav-arrow gallery-nav-arrow--prev';
      nextButton.className = 'gallery-nav-arrow gallery-nav-arrow--next';
      
      prevButton.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      nextButton.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      
      prevButton.setAttribute('aria-label', 'Previous image');
      nextButton.setAttribute('aria-label', 'Next image');
      
      prevButton.setAttribute('type', 'button');
      nextButton.setAttribute('type', 'button');
      
      // Append to product gallery (not carousel) so they persist
      productGallery.style.position = 'relative';
      productGallery.appendChild(prevButton);
      productGallery.appendChild(nextButton);
      
      // Add click handlers
      prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Previous clicked');
        navigate('prev');
      });
      
      nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Next clicked');
        navigate('next');
      });
      
      console.log('Navigation arrows created and added');
    }
    
    // Navigate function
    function navigate(direction) {
      const allSlides = getAllSlides();
      if (allSlides.length === 0) return;
      
      console.log('Current index before:', currentSlideIndex);
      
      if (direction === 'prev') {
        currentSlideIndex = currentSlideIndex > 0 ? currentSlideIndex - 1 : allSlides.length - 1;
      } else {
        currentSlideIndex = currentSlideIndex < allSlides.length - 1 ? currentSlideIndex + 1 : 0;
      }
      
      console.log('New index:', currentSlideIndex);
      
      const targetSlide = allSlides[currentSlideIndex];
      
      if (targetSlide) {
        // Scroll to target
        targetSlide.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'nearest', 
          inline: 'center' 
        });
        
        // Update classes and thumbnails
        setTimeout(() => {
          allSlides.forEach((slide, idx) => {
            if (idx === currentSlideIndex) {
              slide.classList.add('is-initial');
              slide.setAttribute('aria-current', 'true');
            } else {
              slide.classList.remove('is-initial');
              slide.setAttribute('aria-current', 'false');
            }
          });
          
          updateThumbnails(targetSlide);
        }, 50);
      }
    }
    
    // Update thumbnails
    function updateThumbnails(targetSlide) {
      const mediaId = targetSlide.getAttribute('data-media-id');
      const thumbnails = productGallery.querySelectorAll('.product-gallery__thumbnail');
      
      thumbnails.forEach(thumb => {
        if (thumb.getAttribute('data-media-id') === mediaId) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.setAttribute('aria-current', 'false');
        }
      });
    }
    
    // Sync when thumbnails are clicked
    function syncThumbnails() {
      const thumbnails = productGallery.querySelectorAll('.product-gallery__thumbnail');
      thumbnails.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          currentSlideIndex = index;
          console.log('Thumbnail clicked, index now:', currentSlideIndex);
        });
      });
    }
    
    // Initialize current index based on which slide has is-initial
    function initIndex() {
      const allSlides = getAllSlides();
      allSlides.forEach((slide, idx) => {
        if (slide.classList.contains('is-initial')) {
          currentSlideIndex = idx;
        }
      });
      console.log('Initial slide index:', currentSlideIndex);
    }
    
    // Initialize
    createArrows();
    syncThumbnails();
    initIndex();
    
    // Use MutationObserver to watch for carousel changes and ensure arrows persist
    const observer = new MutationObserver((mutations) => {
      // Check if arrows still exist
      const prevExists = document.querySelector('.gallery-nav-arrow--prev');
      const nextExists = document.querySelector('.gallery-nav-arrow--next');
      
      if (!prevExists || !nextExists) {
        console.log('Arrows were removed, re-creating...');
        createArrows();
      }
    });
    
    // Observe the product gallery for changes
    observer.observe(productGallery, {
      childList: true,
      subtree: true
    });
    
    console.log('Gallery navigation initialized with persistent arrows');
  }, 100);
}